<form [formGroup]="rootForm" *ngIf="! currentControl.disabled">
  <div class="form-group form-row mx-1">
    <label mat-raised-button [matTooltip]="infoBulle" matTooltipClass="tooltip-large" [matTooltipPosition]="positionIB" [for]="idHtml" class="form-label">{{libelle$ | async }}
      <i *ngIf="infoBulle !== ''"  class="material-icons md-dark md-18"
        aria-hidden="true">
        info
      </i>
    </label>
    <div class="input-group">
      <div class="input-group-preprend" *ngIf="prefixe">
        <span class="input-group-text">{{prefixe}}</span>
      </div>
      <input [readOnly]="afficherEnLectureSeule" [max]="max" [sep]="sep" type="text" min="0" [class.is-warning]="aErreurCroiseeActive()"
        [class.is-invalid]="champInvalide()" [class.is-valid]="champValide()" [formControlName]="labelAffichage"
        class="form-control" [id]="idHtml">
    </div>

    <bis-affiche-erreurs class="col-12" *ngIf="erreursAffichable()" [erreurs]="rootForm.get(label).errors">
    </bis-affiche-erreurs>
  </div>
</form>
